import {Component, Input, OnInit} from '@angular/core';
import {PaymentService} from '../../services/payment.service';
import {NbDialogRef} from '@nebular/theme';
import Swal, {SweetAlertIcon} from 'sweetalert2';
import {environment} from '../../../environments/environment';

@Component({
  selector: 'ngx-create-payment-reference',
  templateUrl: './create-payment-reference.component.html',
  styleUrls: ['./create-payment-reference.component.scss'],
})
export class CreatePaymentReferenceComponent implements OnInit {
  @Input() station: any;
  @Input() type: any;

  loading = false;

  customer = { name: '', last_name: '', phone_number: '', email: '' };

  constructor(
    private paymentService: PaymentService,
    protected ref: NbDialogRef<CreatePaymentReferenceComponent>,
  ) { }

  ngOnInit() {
  }

  close() {
    this.ref.close(false);
  }

  async createReference() {
    this.loading = true;
    let err, response;
    if (this.type === 1) [err, response] = await this.paymentService.createReferenceSpei(this.station.id, this.station.durationTime, this.customer);
      else [err, response] = await this.paymentService.createReferenceStore(this.station.id, this.station.durationTime, this.customer);
    this.loading = false;
    if (err) {
      this.close();
      await this.alert('Oops, ocurrio intentalo mas tarde', 'error');
      return;
    }
    this.close();
    const reference = this.type === 1 ? response.charge.id : response.charge.payment_method.reference;
    const baseUrl = this.type === 1 ? environment.urlReceiptSpei : environment.urlReceipt;
    const urlDowloadFile = `<a target="_blank" href="${baseUrl}/${reference}">Descargar recibo</a>`;
    await this.alert('Referencia creada', 'success', 'Puedes descargar la referencia las veces que necesites en el apartado de "Historial"', urlDowloadFile);
    return;
  }

  async alert(title: string = 'asdasd', icon: SweetAlertIcon = 'success', text: string = '', footer = '') {
    await Swal.fire({
      icon,
      title,
      text,
      footer,
    });
  }

}
